import React, { useState, useEffect, useMemo } from 'react';

import { dataGridPremiumColumns } from '../../../utils/helper';
import { DataGridIdentifiers, DatagridPremiumUi } from '../../Interface';
import alertFormService from '../../../service/Alert/alertForm.service';
import { AlertTypeEnum, AlertTypeList } from '../../../config/alert';

const AlertFormReports = ({
  refetch,
  values,
  viewField,
  operatorsDisabled,
  rowSelection,
  autocompleteOptions,
  autocompleteData,
}) => {
  const { refetchTable, setRefetchTable } = refetch;
  const { setSelectedValues } = values;
  const { rowSelectionModel, setRowSelectionModel } = rowSelection;

  const [reports, setReports] = useState({ rows: [], rowCount: 0 });

  const initialState = {
    filter: { filterModel: { items: [], logicOperator: 'and' } },
    sorting: {
      sortModel: [{ field: 'id', sort: 'asc' }],
    },
    pagination: {
      paginationModel: {
        pageSize: 25,
        page: 0,
      },
    },
    density: 'compact',
  };

  useEffect(() => {
    if (operatorsDisabled) {
      setRowSelectionModel([]);
    }
  }, [operatorsDisabled]);

  const getList = (gridState) => {
    alertFormService.getItems(gridState).then((data) => {
      setReports(data);
    });
  };

  const columns = useMemo(() => {
    return dataGridPremiumColumns([
      {
        field: 'id',
        headerName: '#',
        type: 'string',
        filterable: false,
      },
      {
        field: 'name',
        headerName: 'Riasztás neve',
        type: 'string',
      },
      {
        field: 'type',
        headerName: 'Típus',
        type: 'singleSelect',
        valueOptions: AlertTypeList,
        valueGetter: (_value, row) => row.type ?? AlertTypeEnum.ALERT,
        valueFormatter: (value) => AlertTypeList.find((item) => item.value === value)?.label ?? value,
      },
      {
        field: 'view',
        headerName: 'Riasztás forrása',
        type: 'singleSelect',
        sortable: false,
        renderCell: (data) => {
          if (data.row.type === AlertTypeEnum.DASHBOARD_EMAIL) return '';
          return data.row.views?.name;
        },
        valueOptions: autocompleteOptions.views,
      },
      {
        field: 'dashboardId',
        headerName: 'Dashboard',
        type: 'singleSelect',
        renderCell: (data) => {
          if ((data.row.type ?? AlertTypeEnum.ALERT) !== AlertTypeEnum.DASHBOARD_EMAIL) return '';
          return (
            data.row.dashboard?.name ??
            autocompleteOptions.dashboards.find((dashboard) => dashboard.value === data.row.dashboardId)?.label ??
            ''
          );
        },
        valueOptions: autocompleteOptions.dashboards,
      },
      {
        field: 'description',
        headerName: 'Leírás',
        type: 'string',
      },
    ]);
  }, [autocompleteOptions]);

  return (
    <DatagridPremiumUi
      datagridIdentifier={DataGridIdentifiers.AlertForm}
      datagridInitialState={initialState}
      dataLoader={getList}
      rows={reports.rows}
      refetch={{ refetchTable, setRefetchTable }}
      rowCount={reports.rowCount}
      columns={[...columns]}
      onRowClick={(rowData) => {
        if (!viewField) return;
        setSelectedValues(rowData.row);
      }}
      paginationAndfilterMode="server"
      onRowSelectionModelChange={(newRowSelectionModel) => {
        setRowSelectionModel(newRowSelectionModel);
      }}
      rowSelectionModel={rowSelectionModel}
      disableRowSelectionOnClick={!viewField}
    />
  );
};

export default AlertFormReports;
